import React from "react";
import ReservedCard from "./ReservedCard";
import { Wallet } from "lucide-react";

const ReservedPage = ({ data }) => {
const list = data?.allocations || [];
    const balance = data?.availableBalance;

    const formattedBalance = balance
    ? Number(balance).toLocaleString("en-IN")
    : "N/A";

  return (
    <div className="customer-port-folio-positional-container">
        <div className="customer-port-folio-balance-card">
            <div className="customer-port-folio-balance-icon">
            <Wallet size={22}/>
            </div>
            <div className="customer-port-folio-balance-info">
            <span className="customer-port-folio-balance-label">
            Available Balance
            </span>

            <span className="customer-port-folio-balance-amount">
            ₹{formattedBalance}
            </span>
            </div>
            </div>
            <div className="customer-port-folio-positional-list">
            {list.map((item)=>(
            <ReservedCard key={item._id} item={item}/>
            ))}
            </div>
    </div>
  );

};

export default ReservedPage;